export const productsData1 = [
  {
    name: "Rose des Vents",
    sizes: "150ml",
    price: 125,
    photoName: "foto/louis-vuitton-rose-des-vents-1.avif",
  },
  {
    name: "Heures d'Absence",
    sizes: "100ml",
    price: 130,
    photoName: "foto/louis-vuitton-heures-d-absence-2.avif",
  },
  {
    name: "Coeur Battant",
    sizes: "100ml",
    price: 137,
    photoName: "foto/louis-vuitton-coeur-battant-1.avif",
  },
  {
    name: "Étoile Filante",
    sizes: "50ml",
    price: 140,
    photoName: "foto/louis-vuitton-étoile-filante-1.avif",
  },
  {
    name: "Apogée",
    sizes: "100ml",
    price: 145,
    photoName: "foto/louis-vuitton-apogée-1.avif",
  },
  {
    name: "Spell on You",
    sizes: "100ml",
    price: 147,
    photoName: "foto/spellOnYou.avif",
  },
  {
    name: "Attrape-Rêves",
    sizes: "100ml",
    price: 160,
    photoName: "foto/louis-vuitton-attrape-rêves-1.avif",
  },
  {
    name: "Ombre Nomade",
    sizes: "100ml",
    price: 152,
    photoName: "foto/louis-vuitton-ombre-nomade-1.avif",
  },
  {
    name: "Fleur du Désert",
    sizes: "100ml",
    price: 170,
    photoName: "foto/louis-vuitton-fleur-du-désert-1.avif",
  },
];
